import jwtDecode from 'jwt-decode'
import axios from 'axios'
import { analyticsIdentify } from './analytics'

const authenticateAnovaIdentity = async (firebaseJWT) => {
  const authenticateResponse = await axios.post('/ali/authenticate', {
    firebaseJWT
  })

  const anovaJWT = authenticateResponse.data.jwt
  const anovaJWTClaims = jwtDecode(authenticateResponse.data.jwt)

  analyticsIdentify(anovaJWTClaims.id, {
    name: anovaJWTClaims.name,
    email: anovaJWTClaims.email
  })

  return anovaJWT
}

export default authenticateAnovaIdentity
